<template>
    <div class="averrage-elec">
        <me-collapes v-if="false" @collapesCb="collapesCb">
            <div style="height: 750px">
                <div class="tree-wrap">
                    <me-tree
                        ref="myTree"
                        :treeData="data"
                        :treeLoading="treeLoading"
                        :treeToolBar="false"
                        :defaultProps="defaultProps"
                        :nodeKey="'point_id'"
                        :showCheckbox="true"
                        :title="'采集点选择'"
                        :cascadingVar="true"
                        :checkStrictly.sync="checkStrictly"
                        :isCheckClick="true"
                        :defaultCheckKeys="defaultCheckKeys"
                        :defaultExpandedKeys="defaultCheckKeys"
                        @handleCheckBoxClick="handleTreeNodeClick"
                    ></me-tree>
                </div>
            </div>
        </me-collapes>
        <div
            class="leader-tab power-tab right_container"
            :style="{ width: width }"
            style="margin-left: 40px"
        >
            <div class="search_cont">
                <el-form
                    :inline="true"
                    :model="searchForm"
                    class="leader-style-form leader-form-inner-tab-inline"
                >
                    <el-form-item label="时间" style="float: left">
                        <el-date-picker
                            v-model="time"
                            type="month"
                            :clearable="false"
                            placeholder="选择月"
                            value-format="yyyy-MM"
                            :picker-options="pickerOptions"
                            @change="handleTimeChange"
                            v-show="tabVal === 'month'"
                        ></el-date-picker>
                        <el-button size="small" @click="forwardTimeClick" style="margin-left: 10px">
                            上一{{
                                tabVal === "day"
                                    ? "日"
                                    : tabVal === "month"
                                        ? "月"
                                        : "年"
                            }}
                        </el-button>
                        <el-button size="small" :disabled="nextTimeDisabled" @click="nextTimeClick">
                            下一{{
                                tabVal === "day"
                                    ? "日"
                                    : tabVal === "month"
                                        ? "月"
                                        : "年"
                            }}
                            <!-- <i class="el-icon-caret-right"></i> -->
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
            <el-scrollbar style="height: 100%;width:100%;">
                <div class="table_cont-wrap">
                    <v-chart
                        class="vchart-class"
                        auto-resize
                        :options="lineHBar"
                        ref="chart"
                        theme="ovilia-green"
                    />
                    <div class="month-price" v-if="false">
                        <div class="month-item">
                            <v-chart
                                class="chart-wrap"
                                :auto-resize="true"
                                :options="barValue01"
                                ref="barValue01"
                                theme="ovilia-green"
                            />
                        </div>
                        <div class="month-item" style="margin-left: 20px">
                            <v-chart
                                class="chart-wrap"
                                :auto-resize="true"
                                :options="barValue02"
                                ref="barValue02"
                                theme="ovilia-green"
                            />
                        </div>
                    </div>
                    <div class="month-price" v-if="isShow">
                        <div class="month-item">
                            <v-chart
                                class="chart-wrap"
                                :auto-resize="true"
                                :options="barValue03"
                                ref="barValue03"
                                theme="ovilia-green"
                                @click="barClick"
                            />
                        </div>
                        <div class="month-item" style="margin-left: 20px">
                            <v-chart
                                class="chart-wrap"
                                :auto-resize="true"
                                :options="barValue04"
                                ref="barValue04"
                                theme="ovilia-green"
                                @click="barClick"
                            />
                        </div>
                    </div>
                    <v-chart
                        class="vchart-class"
                        :auto-resize="true"
                        :options="duiBar"
                        ref="duiBar"
                        v-if="isShowBar"
                        theme="ovilia-green"
                    />
                </div>
            </el-scrollbar>
        </div>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
// import moment from "moment";
import dayjs from "dayjs";
import * as api from "@/http/api.js";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/graphic";
import utils from "@/utils/utils";
export default {
    components: {
        "me-tree": Tree,
        "me-collapes": Collapes
    },
    filters: {
        // 2. 局部过滤器
        floatFormat(value) {
            return parseInt(value * 100) / 100;
        }
    },
    data() {
        return {
            tabVal: "month",
            time: "",
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            nextTimeDisabled: false,
            todayY: "",
            todayM: "",
            todayD: "",
            data: [],
            treeLoading: false,
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            checkStrictly: true,
            defaultCheckKeys: [],
            nodeKey: "point_id",
            tableData: {},
            tableLoading: false,
            systemDate: {},
            width: "calc(100% - 80px)",
            yHAxis: [],
            xHAxis: [],
            yearMonthTitile: "",
            nextyearMonthTitile: "",
            isShow: false,
            isShowBar: false,
            hBarYdata1: [],
            hbarSData1: [],
            hBarYdata2: [],
            hbarSData2: [],
            dayDataX: [],
            bardata1: [],
            bardata2: [],
            bardata3: [],
            bardata4: [],
            duibarTitle: ""
        };
    },
    created() {
        this.getSysDate("day");

        this.nextTimeDisabled = true;
    },
    mounted() {
        const chart = this.$refs.chart.chart;
        //使点击区域变成pointer
        chart.getZr().on("mousemove", function (params) {
            var pointInPixel = [params.offsetX, params.offsetY];
            if (chart.containPixel("grid", pointInPixel)) {
                chart.getZr().setCursorStyle("pointer");
            }
        });
        //折线图区域点击事件
        chart.getZr().on("click", params => {
            var pointInPixel = [params.offsetX, params.offsetY];
            var pointInGrid = chart.convertFromPixel("grid", pointInPixel);
            var category = chart.getModel().get("xAxis")[0].data[
                pointInGrid[0]
            ];
            if (undefined != category) {
                this.yearMonthTitile = category;
                this.isShow = true;
                this.isShowBar = false;
                this.getMonthRate();
            }
        });
    },
    methods: {
        /**
         * 获取系统时间
         */
        getSysDate(type) {
            api.getSysDate1().then(res => {
                if (res && res.error_code === "0") {
                    this.systemDate = res.bus_json;
                    this.time = res.bus_json.sysdate;
                    this.getMonthList();
                }
            });
        },
        /**
         * 获取18个月数据
         */
        getMonthList() {
            api.getMonthList({
                show_month: this.time
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.xHAxis = res.bus_json.xList;
                    this.yHAxis = res.bus_json.yList;
                }
            });
        },
        /**
         * 获取18个月数据
         */
        getMonthRate() {
            // if(''!==this.yearMonthTitile||'undefined'===this.yearMonthTitile){
            if (undefined != this.yearMonthTitile) {
                api.getMonthRate({
                    show_month: this.yearMonthTitile
                }).then(res => {
                    if (res && res.error_code === "0") {
                        this.hBarYdata1 = [];
                        this.hBarYdata2 = [];
                        this.hbarSData1 = [];
                        this.hbarSData2 = [];
                        this.hBarYdata1 = res.bus_json.xList1;
                        res.bus_json.yList1.forEach(item => {
                            var single = {};
                            single.value = item.rate;
                            if (item.rate > 0) {
                                single.label = "labelRight";
                            } else {
                                single.label = "";
                            }
                            single.year_month = item.year_month;
                            single.target_unit_id = item.target_unit_id;
                            this.hbarSData1.push(single);
                        });

                        this.hBarYdata2 = res.bus_json.xList2;
                        res.bus_json.yList2.forEach(item => {
                            var single = {};
                            single.value = item.rate;
                            if (item.rate > 0) {
                                single.label = "labelRight";
                            } else {
                                single.label = "";
                            }
                            single.year_month = item.year_month;
                            single.target_unit_id = item.target_unit_id;
                            this.hbarSData2.push(single);
                        });
                    }
                });
            }
        },
        /**
         * 按天
         */
        getDayList(param) {
            api.getDayList({
                show_month: param.data.year_month,
                target_unit_id: param.data.target_unit_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.dayDataX = [];
                    this.bardata1 = [];
                    this.bardata2 = [];
                    this.bardata3 = [];
                    this.bardata4 = [];
                    this.dayDataX = res.bus_json.xList;
                    this.bardata1 = res.bus_json.yList1;
                    this.bardata2 = res.bus_json.yList2;
                    this.bardata3 = res.bus_json.yList3;
                    this.bardata4 = res.bus_json.yList4;
                }
            });
        },
        /**
         *线形图点击事件
         * **/
        lineChartClick(param) {
            console.log("圆点点击：", param);
            this.yearMonthTitile = param.name;
            this.isShow = true;
            this.isShowBar = false;
            this.getMonthRate();
        },
        /**
         *柱状图点击事件
         * **/
        barClick(param) {
            this.nextyearMonthTitile = param.data.year_month;
            this.duibarTitle = param.name;
            this.isShowBar = true;
            this.getDayList(param);
        },
        /**
         * 日期改变回调函数
         */
        handleTimeChange(val) {
            let toDay = new Date(this.toDay).getTime();
            let selectTime = new Date(val).getTime();
            if (selectTime >= toDay) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
            this.getMonthList();
            this.isShow = false;
            this.isShowBar = false;
        },
        /**
         * 下一日、下一月、下一年点击
         */

        nextTimeClick() {
            let todayD = new Date(this.todayD).getTime();
            let todayM = new Date(this.todayM).getTime();
            let todayY = new Date(this.todayY).getTime();
            if (this.tabVal === "day") {
                this.time = dayjs(new Date(this.time))
                    .add(1, "days")
                    .format("YYYY-MM-DD");
            } else if (this.tabVal === "month") {
                this.time = dayjs(new Date(this.time))
                    .add(1, "months")
                    .format("YYYY-MM");
            } else {
                this.time = dayjs(new Date(this.time))
                    .add(1, "years")
                    .format("YYYY");
            }
            // 获取数据
            this.getMonthList();
            this.isShow = false;
            this.isShowBar = false;
            let selectTime = new Date(this.time).getTime();
            if (
                (this.tabVal === "day" && selectTime >= todayD) ||
                (this.tabVal === "month" && selectTime >= todayM) ||
                (this.tabVal === "year" && selectTime >= todayY)
            ) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
        },
        /**
         * 上一日、上一月、上一年点击
         */
        forwardTimeClick() {
            this.nextTimeDisabled = false;
            if (this.tabVal === "day") {
                this.time = dayjs(new Date(this.time))
                    .subtract(1, "days")
                    .format("YYYY-MM-DD");
            } else if (this.tabVal === "month") {
                this.time = dayjs(new Date(this.time))
                    .subtract(1, "months")
                    .format("YYYY-MM");
            } else {
                this.time = dayjs(new Date(this.time))
                    .subtract(1, "years")
                    .format("YYYY");
            }
            // 获取数据
            this.getMonthList();
            this.isShow = false;
            this.isShowBar = false;
        },
        /**
         * 监听树结构收起展开
         */
        collapesCb(collapes) {
            this.width = collapes ? "calc(100% - 370px)" : "calc(100% - 56px)";
        }
    },
    computed: {
        lineHBar() {
            const options = {
                color: "#409eff",
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    },
                    formatter: function (params) {
                        var tar = params[0];
                        return (
                            tar.marker +
                            tar.name +
                            "：" +
                            tar.value +
                            " 元/kW·h"
                        );
                    }
                },
                legend: {
                    textStyle: {
                        color: utils.getFontColor() //字体颜色
                    },
                    data: ["平均电价"]
                },
                grid: {
                    left: "5%",
                    right: "4%",
                    top: "10%",
                    bottom: "10%",
                    containLabel: true
                },
                xAxis: [
                    {
                        name: "",
                        type: "category",
                        // boundaryGap: false,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor() //颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        },
                        axisTick: {
                            alignWithLabel: true
                        },
                        data: this.xHAxis
                        // data: [
                        //     '2019-12',
                        //     '2020-01',
                        //     '2020-02',
                        //     '2020-03',
                        //     '2020-04',
                        //     '2020-05',
                        //     '2020-06',
                        //     '2020-07',
                        //     '2020-08',
                        //     '2020-09',
                        //     '2020-10',
                        //     '2020-11',
                        //     '2020-12',
                        //     '2021-01',
                        //     '2021-02',
                        //     '2021-03',
                        //     '2021-04',
                        //     '2021-05',
                        // ],
                    }
                ],
                yAxis: [
                    {
                        name: "元/kW·h",
                        type: "value",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor() //颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        },
                        nameTextStyle: {
                            color: "white",
                            padding: 10,
                            fontSize: 14
                        }
                    }
                ],
                series: [
                    {
                        name: "平均电价",
                        data: this.yHAxis,
                        // data: [
                        //     '0',
                        //     '0.675026',
                        //     '0.712405',
                        //     '0.666130',
                        //     '0.661451',
                        //     '0.638725',
                        //     '0.642669',
                        //     '0.671516',
                        //     '0.636294',
                        //     '0.666130',
                        //     '0.661451',
                        //     '0.638725',
                        //     '0.642669',
                        //     '0.671516',
                        //     '0.636294',
                        //     '0.638725',
                        //     '0.642669',
                        //     '0',
                        // ],
                        type: "line"
                    }
                ]
            };
            return options;
        },
        barValue01() {
            var labelRight = {
                position: "right"
            };
            const option = {
                title: {
                    text: "10月各分厂对全厂平均电价的影响比例",
                    textStyle: {
                        color: utils.getFontColor() //字体颜色
                    },
                    left: "center"
                    // subtext: "From ExcelHome"
                    // sublink: 'http://e.weibo.com/1341556070/AjwF2AgQm'
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: "5%",
                    right: "4%",
                    top: "15%",
                    bottom: "10%"
                },
                xAxis: {
                    type: "value",
                    position: "top",
                    splitLine: {
                        lineStyle: {
                            type: "dashed"
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: utils.getFontColor()
                        }
                    }
                },
                yAxis: {
                    type: "category",
                    axisLine: { show: false },
                    axisLabel: { show: false },
                    axisTick: { show: false },
                    splitLine: { show: false },
                    data: [
                        "ten",
                        "nine",
                        "eight",
                        "seven",
                        "six",
                        "five",
                        "four",
                        "three",
                        "two",
                        "one"
                    ]
                },
                series: [
                    {
                        name: "生活费",
                        type: "bar",
                        stack: "总量",
                        label: {
                            show: true,
                            formatter: "{b}"
                        },
                        data: [
                            { value: -0.07, label: labelRight },
                            { value: -0.09, label: labelRight },
                            0.2,
                            0.44,
                            { value: -0.23, label: labelRight },
                            0.08,
                            { value: -0.17, label: labelRight },
                            0.47,
                            { value: -0.36, label: labelRight },
                            0.18
                        ],
                        itemStyle: {
                            color: utils.getFontColor() //字体颜色
                        }
                    }
                ]
            };
            return option;
        },
        barValue02() {
            var labelRight = {
                position: "right"
            };
            const option = {
                title: {
                    text: "去年同期各分厂对全厂平均电价的影响比例",
                    textStyle: {
                        color: utils.getFontColor() //字体颜色
                    },
                    left: "center"
                    // subtext: "From ExcelHome"
                    // sublink: 'http://e.weibo.com/1341556070/AjwF2AgQm'
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: "5%",
                    right: "4%",
                    top: "15%",
                    bottom: "10%"
                },
                xAxis: {
                    type: "value",
                    position: "top",
                    splitLine: {
                        lineStyle: {
                            type: "dashed"
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: utils.getFontColor()
                        }
                    }
                },
                yAxis: {
                    type: "category",
                    axisLine: { show: false },
                    axisLabel: { show: false },
                    axisTick: { show: false },
                    splitLine: { show: false },
                    data: [
                        "ten",
                        "nine",
                        "eight",
                        "seven",
                        "six",
                        "five",
                        "four",
                        "three",
                        "two",
                        "one"
                    ]
                },
                series: [
                    {
                        name: "生活费",
                        type: "bar",
                        stack: "总量",
                        label: {
                            show: true,
                            formatter: "{b}"
                        },
                        data: [
                            { value: -0.07, label: labelRight },
                            { value: -0.09, label: labelRight },
                            0.2,
                            0.44,
                            { value: -0.23, label: labelRight },
                            0.08,
                            { value: -0.17, label: labelRight },
                            0.47,
                            { value: -0.36, label: labelRight },
                            0.18
                        ],
                        itemStyle: {
                            color: utils.getFontColor() //字体颜色
                        }
                    }
                ]
            };
            return option;
        },
        barValue03() {
            var labelRight = {
                position: "right"
            };
            const option = {
                title: {
                    text:
                        this.yearMonthTitile +
                        "月各部门对全厂平均电价的影响比例",
                    textStyle: {
                        color: utils.getFontColor() //字体颜色
                    },
                    left: "center"
                },
                tooltip: {
                    trigger: "item",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    },
                    formatter: function (params) {
                        var tar = params;
                        return tar.marker + tar.name + "：" + tar.value + "%";
                    }
                },
                grid: {
                    left: "15%",
                    right: "4%",
                    top: "15%",
                    bottom: "10%"
                },
                xAxis: {
                    type: "value",
                    position: "top",
                    splitLine: {
                        lineStyle: {
                            type: "dashed"
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: utils.getFontColor()
                        }
                    },
                    axisLabel: {
                        color: utils.getFontColor() //字体颜色
                    }
                },
                yAxis: {
                    type: "category",
                    data: this.hBarYdata1,
                    axisLabel: {
                        color: utils.getFontColor() //字体颜色
                    }
                },
                series: [
                    {
                        name: "",
                        type: "bar",
                        data: this.hbarSData1,
                        itemStyle: {
                            color: utils.getFontColor() //字体颜色
                        }
                    }
                ]
            };
            return option;
        },
        barValue04() {
            var labelRight = {
                position: "right"
            };
            const option = {
                title: {
                    text: "去年同期各部门对全厂平均电价的影响比例",
                    textStyle: {
                        color: utils.getFontColor() //字体颜色
                    },
                    left: "center"
                },
                tooltip: {
                    trigger: "item",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    },
                    formatter: function (params) {
                        var tar = params;
                        return tar.marker + tar.name + "：" + tar.value + "%";
                    }
                },
                grid: {
                    left: "15%",
                    right: "4%",
                    top: "15%",
                    bottom: "10%"
                },
                xAxis: {
                    type: "value",
                    position: "top",
                    splitLine: {
                        lineStyle: {
                            type: "dashed"
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: utils.getFontColor()
                        }
                    },
                    axisLabel: {
                        color: utils.getFontColor() //字体颜色
                    }
                },
                yAxis: {
                    type: "category",
                    data: this.hBarYdata2,
                    axisLabel: {
                        color: utils.getFontColor() //字体颜色
                    }
                    // data: ["ten", "nine", "eight", "seven", "six", "five", "four", "three", "two", "one"]
                },
                series: [
                    {
                        name: "",
                        type: "bar",
                        data: this.hbarSData2,
                        // data: [
                        //     { value: -0.07, label: labelRight },
                        //     { value: -0.09, label: labelRight },
                        //     0.2, 0.44,
                        //     { value: -0.23, label: labelRight },
                        //     0.08,
                        //     { value: -0.17, label: labelRight },
                        //     0.47,
                        //     { value: -0.36, label: labelRight },
                        //     0.18
                        // ],
                        itemStyle: {
                            color: utils.getFontColor() //字体颜色
                        }
                    }
                ]
            };
            return option;
        },
        duiBar() {
            const option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    },
                    formatter: function (params) {
                        var showData = params[0].name + "<br/>";
                        params.forEach(tar => {
                            showData +=
                                tar.marker +
                                tar.seriesName +
                                "：" +
                                tar.data +
                                " kW·h" +
                                "<br/>";
                        });
                        return showData;
                        console.log(params);
                    }
                },
                title: {
                    text:
                        this.nextyearMonthTitile +
                        "月" +
                        this.duibarTitle +
                        "用电量趋势",
                    textStyle: {
                        color: utils.getFontColor() //字体颜色
                    },
                    left: "center"
                },
                legend: {
                    top: "8%",
                    // data: ["直接访问", "邮件营销", "联盟广告", "视频广告", "搜索引擎", "百度", "谷歌", "必应", "其他"],
                    textStyle: {
                        color: utils.getFontColor() //字体颜色
                    }
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "18%",
                    top: "15%"
                },
                xAxis: [
                    {
                        type: "category",
                        data: this.dayDataX,
                        axisLabel: {
                            color: utils.getFontColor() //字体颜色
                        }
                    }
                ],
                yAxis: [
                    {
                        name: "kW·h",
                        nameTextStyle: {
                            color: utils.getFontColor() //字体颜色
                        },
                        type: "value",
                        axisLabel: {
                            color: utils.getFontColor() //字体颜色
                        }
                    }
                ],
                series: [
                    {
                        name: "尖电量",
                        type: "bar",
                        data: this.bardata1,
                        stack: "aaa",
                        itemStyle: {
                            color: "#fe7f66" //字体颜色
                        }
                    },
                    {
                        name: "峰电量",
                        type: "bar",
                        stack: "aaa",
                        data: this.bardata2,
                        itemStyle: {
                            color: "#fdca50" //字体颜色
                        }
                    },
                    {
                        name: "平电量",
                        type: "bar",
                        stack: "aaa",
                        data: this.bardata3,
                        itemStyle: {
                            color: "#0091ea" //字体颜色
                        }
                    },
                    {
                        name: "谷电量",
                        type: "bar",
                        stack: "aaa",
                        data: this.bardata4,
                        itemStyle: {
                            color: "#29b85e" //字体颜色
                        }
                    }
                ]
            };

            return option;
        }
    }
};
</script>
<style lang="scss">
// @import '../../../../assets/css/date-picker';
.el-tabs__item {
    color: #fff;
}

.el-tabs--card {
    margin: 0;
}

.averrage-elec {
    width: 100%;
    height: 85%;
    display: flex;
    flex-direction: row;
    // .tree-wrap {
    //     width: 280px;
    //     // height: 100%;
    //     padding-bottom: 70px;
    //     box-sizing: border-box;
    //     overflow: hidden;
    //     box-sizing: border-box;
    //     border-radius: 5px;
    // }
    .tree-wrap {
        height: 100%;
        // overflow: hidden;
        height: calc(100% - 10px);
        box-sizing: border-box;
    }

    .right_container {
        // height: calc(98% - 5px);
        // // margin-top: 5px;
        // margin: 0 30px 0 0;
        // box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        // border-radius: 5px;
        // box-sizing: border-box;
        // transition: width 500ms;
        .el-tabs--card {
            margin: 0;
        }

        .search_cont {
            width: 100%;
            margin: 15px 0 20px 0;

            .form {
                display: flex;
                justify-content: space-between;

                .button-group {
                    display: inline-block;
                    margin-left: 20px;
                    // button {
                    //     background: rgb(41, 184, 94);
                    //     color: white;
                    //     outline: none;
                    //     border-color: rgb(41, 184, 94);
                    // }
                    .el-button.is-disabled,
                    .el-button.is-disabled:focus,
                    .el-button.is-disabled:hover {
                        border-color: #ebeef5;
                    }
                }

                // .el-input__inner {
                //     height: 36px;
                //     line-height: 36px;
                // }
            }
        }

        .table_cont-wrap {
            width: 100%;
            padding: 0;
            box-sizing: border-box;
            /*overflow: hidden;*/

            .green {
                height: 12px;
                width: 5px;
                background: #0089f1;
                margin: 10px;
                float: left;
            }

            width: 100%;
            font-size: 16px;
            text-align: left;
            line-height: 32px;

            .month-price {
                display: flex;
                margin-top: 20px;

                .month-item {
                    flex-grow: 1;
                    background-size: 100% 100%;
                    padding-top: 20px;
                    .chart-wrap {
                        width: px2Rem(775px);
                        height: px2Rem(400px);
                    }
                    v-chart {
                        width: 775px;
                        height: 400px;
                    }
                }
            }

            .vchart-class {
                width: 100%;
                height: px2Rem(500px);
                background-size: 100% 100%;
            }
        }

        .table-wrap-n {
            // width: 100%;
            // overflow: auto;
            // font-size: 14px;
            font-size: 14px;
            width: 100%;
            padding: 30px 30px 0 30px;
            box-sizing: border-box;
            height: px2Rem(500) px;
            margin: 0;
            position: relative;
            background-size: 100% 100%;
            overflow: auto;

            .table-header {
                width: 100%;
                display: flex;
                flex-direction: row;

                color: #fff;
                height: 50px;
                line-height: 50px;
                // border-top: 1px solid #ededed;
                // border-left: 1px solid #ededee;
            }

            .table-name {
                min-width: 200px !important;
                box-sizing: border-box;
            }

            .table-header-colum {
                flex: 1;
                // border-right: 1px solid #ededed;
                // border-bottom: 1px solid #ededed;
                // background: #f8f8f8;
                background: rgba(38, 77, 132, 0.6) !important;
                text-align: center;
                min-width: 80px;
                padding: 3px 0;
            }

            .table-row {
                display: flex;
                flex-direction: row;
                min-width: 100%;
                color: #fff;

                // border-left: 1px solid #ededee;
                .table-row-item {
                    flex: 1;
                    // border-right: 1px solid #ededed;
                    // border-bottom: 1px solid #ededed;
                    text-align: center;
                    min-width: 80px;
                    // padding: 3.5px 0;
                }
            }

            .table-row:nth-child(2n) .table-row-item {
                background: transparent !important;
                color: #ffffff;
                height: 50px;
                line-height: 50px;
            }

            .table-row:nth-child(2n + 1) .table-row-item {
                background: rgba(38, 77, 132, 0.6) !important;
                color: #ffffff;
                height: 50px;
                line-height: 50px;
            }

            .table-nodata {
                // border: 1px solid #ededed;
                text-align: center;
                // color: #999;
                color: #fff;
            }
        }
    }
}

// .is-top .is-active {
//     /*color: #56fcff !important;*/
// }

.power-tab {
    margin: 4px 0 0 0;
}
</style>
